// import { Hidden, useTheme } from "@mui/material";
// import React from "react";
// import { useTranslation } from "react-i18next";
// import ButtonLink from "./buttonLink";
// import ButtonLinkFab from "./buttonLinkFab";
// const Add = ({ link, item, onAdd, title, type = "normal | fab | iconOnly" }) => {
//   const { t } = useTranslation(["common"]);
//   const theme=useTheme();
//   return (<>
//     <Hidden only={["md", "lg", "xl"]}>
//       <ButtonLinkFab
//         title={title}
//         link={link}
//         item={item}
//         icon={"add"}
//         onAdd={onAdd}
//       />
//     </Hidden>
//     <Hidden only={["xs", "sm"]}>
//       <ButtonLink 
//         title={title}
//         link={link}
//         item={item}
//         icon={"add_circle"}
//         color="primary"
//         onAdd={onAdd}
//       />
//     </Hidden>
//   </>)
// };

// export default Add;


import { AddCircleOutlineTwoTone } from "@mui/icons-material";
import { Button, Hidden, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const Add = ({ link, item, title, icon="add_circle",color="primary", variant = "contained",size="small", onAdd,target,...rest }) => {
  const { t } = useTranslation(["common"]);
  const useStyles = makeStyles((theme) => ({
    buttonSpace: {
        margin: theme.spacing(1),
    },
  }));
const classes=useStyles();

  return (
    <React.Fragment>
      <Hidden only={["xs", "sm"]}>
        {link ? (
          <Link to={link} target={target} {...rest} >
            <Button
              title={title}
              color={color}
              variant={variant ? variant : "contained"}
              size={size}
              startIcon={icon?<AddCircleOutlineTwoTone/>
              :"" }
              {...rest}
            >
              {t("common:" + title)}
            </Button>
          </Link>
        ) : (
          <Button
          title={title}
            color={color}
            variant={variant ? variant : "contained"}
            className={classes.buttonSpace}
            size={size}
            onClick={(event) => onAdd(item,event)}
            startIcon={icon?<AddCircleOutlineTwoTone/>:"" }
            {...rest}
          >
            {title && t("common:" + title)}
          </Button>
        )}
      </Hidden>
      <Hidden only={["md", "lg", "xl"]}>
        {link ? (
          <Link to={link}>
            <IconButton title={title} color={color} aria-label={title} {...rest} size="large">
              {/* <Icon baseClassName="material-icons-two-tone">{icon}</Icon> */}
              <AddCircleOutlineTwoTone/>
            </IconButton>
          </Link>
        ) : (
          // <Link to={link}>
            <IconButton
              title={title}
              color={color}
              aria-label={title}
              onClick={(event) => onAdd(item,event)}
              {...rest}
              size="large">
              {/* <Icon baseClassName="material-icons-two-tone">{icon}</Icon> */}
              <AddCircleOutlineTwoTone/>
            </IconButton>
          // </Link>
        )}
      </Hidden>
    </React.Fragment>
  );
};

export default Add;
